import { j as a } from "../../../../../node_modules/react/jsx-runtime.js";
import { useState as l, useEffect as n } from "react";
import { clsx as i } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import e from "../../Table.module.scss.js";
const b = ({ loading: r }) => {
  const [t, s] = l(1);
  return n(() => {
    if (!r) return;
    const o = setInterval(() => {
      s((d) => d % 3 + 1);
    }, 250);
    return () => clearInterval(o);
  }, [r]), r ? /* @__PURE__ */ a.jsxs("div", { className: e.tableLoaderContainer, children: [
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: i(e.tableLoaderBgGradient, {
          "!opacity-100": t === 1,
          "!opacity-0": t !== 1
        }),
        "data-testid": "table-loader-bg-gradient-div-1"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: i(e.tableLoaderBgGradient, {
          "!opacity-100": t === 2,
          "!opacity-0": t !== 2
        }),
        "data-testid": "table-loader-bg-gradient-div-2"
      }
    ),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: i(e.tableLoaderBgGradient, {
          "!opacity-100": t === 3,
          "!opacity-0": t !== 3
        }),
        "data-testid": "table-loader-bg-gradient-div-3"
      }
    )
  ] }) : null;
};
export {
  b as default
};
//# sourceMappingURL=TableLoader.js.map
